import React, { useCallback, useRef } from 'react';
import AddIcon from '@mui/icons-material/Add';

import Section from '../../../layout/Section';
import Button from '../../../common/inputs/Button';
import PPATable, { PPATableRef } from '../../../tables/PPATable';
import { PPATariff, PPATariffCreate, PPATariffUpdate, ValidationEntry } from '../../../../types';

interface PPATariffSectionProps {
    ppaTariffs: PPATariff[];
    canEdit: boolean;
    projektLaufzeit: number;
    onCreatePPA: (data: PPATariffCreate) => Promise<PPATariff>;
    onUpdatePPA: (tariffId: string, data: PPATariffUpdate) => Promise<PPATariff>;
    onDeletePPA: (tariffId: string) => Promise<void>;
    validationEntries?: ValidationEntry[];
    hasWarning?: boolean;
}

/**
 *
 * Eigenständige Section für PPA-Verträge mit Tabelle und Hinzufügen-Button.
 */
const PPATariffSection: React.FC<PPATariffSectionProps> = ({
    ppaTariffs,
    canEdit,
    projektLaufzeit,
    onCreatePPA,
    onUpdatePPA,
    onDeletePPA,
    validationEntries = [],
    hasWarning = false,
}) => {
    const ppaTableRef = useRef<PPATableRef>(null);

    const handleAddPPA = useCallback(() => {
        ppaTableRef.current?.startCreating();
    }, []);

    return (
        <Section
            title="PPA-Verträge"
            noPadding
            hasWarning={hasWarning}
            warningTooltip="Es gibt Warnungen bei den PPA-Verträgen"
            actions={canEdit && (
                <Button
                    variant="primary"
                    startIcon={<AddIcon />}
                    onClick={handleAddPPA}
                >
                    PPA anlegen
                </Button>
            )}
        >
            <PPATable
                ref={ppaTableRef}
                ppaTariffs={ppaTariffs}
                canEdit={canEdit}
                projektLaufzeit={projektLaufzeit}
                validationEntries={validationEntries}
                onCreatePPA={onCreatePPA}
                onUpdatePPA={onUpdatePPA}
                onDeletePPA={onDeletePPA}
            />
        </Section>
    );
};

export default React.memo(PPATariffSection);
